"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = tslib_1.__importStar(require("react"));
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var rc_drawer_1 = tslib_1.__importDefault(require("rc-drawer"));
var getScrollBarSize_1 = tslib_1.__importDefault(require("rc-util/lib/getScrollBarSize"));
var omit_1 = tslib_1.__importDefault(require("rc-util/lib/omit"));
var config_provider_1 = require("../../config-provider");
var NormalClose_1 = require("../../Icons/NormalClose");
var types_1 = require("../../util/types");
require("./style");
var DrawerContext = React.createContext(null);
var PlacementTypes = (0, types_1.tuple)('top', 'right', 'bottom', 'left');
var defaultPushState = { distance: 180 };
var Drawer = /** @class */ (function (_super) {
    tslib_1.__extends(Drawer, _super);
    function Drawer() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            push: false,
        };
        _this.push = function () {
            if (_this.props.push) {
                _this.setState({ push: true });
            }
        };
        _this.pull = function () {
            if (_this.props.push) {
                _this.setState({ push: false });
            }
        };
        _this.onDestroyTransitionEnd = function () {
            var isDestroyOnClose = _this.getDestroyOnClose();
            if (!isDestroyOnClose) {
                return;
            }
            if (!_this.props.visible) {
                _this.destroyClose = true;
                _this.forceUpdate();
            }
        };
        _this.getDestroyOnClose = function () { return _this.props.destroyOnClose && !_this.props.visible; };
        _this.getPushDistance = function () {
            var push = _this.props.push;
            var distance;
            if (typeof push === 'boolean') {
                distance = push ? defaultPushState.distance : 0;
            }
            else {
                distance = push.distance;
            }
            return parseFloat(String(distance || 0));
        };
        // get drawer push width or height
        _this.getPushTransform = function (placement) {
            var distance = _this.getPushDistance();
            if (placement === 'left' || placement === 'right') {
                return "translateX(".concat(placement === 'left' ? distance : -distance, "px)");
            }
            if (placement === 'top' || placement === 'bottom') {
                return "translateY(".concat(placement === 'top' ? distance : -distance, "px)");
            }
        };
        _this.getRcDrawerStyle = function () {
            var _a = _this.props, zIndex = _a.zIndex, placement = _a.placement, mask = _a.mask, style = _a.style;
            var push = _this.state.push;
            // 当无 mask 时，将 width 应用到外层容器上
            // 解决 https://github.com/ant-design/ant-design/issues/12401 的问题
            var offsetStyle = mask ? {} : _this.getOffsetStyle();
            return tslib_1.__assign(tslib_1.__assign({ zIndex: zIndex, transform: push ? _this.getPushTransform(placement) : undefined }, offsetStyle), style);
        };
        // render drawer body dom
        _this.renderBody = function () {
            var _a = _this.props, bodyStyle = _a.bodyStyle, drawerStyle = _a.drawerStyle, prefixCls = _a.prefixCls, visible = _a.visible;
            if (_this.destroyClose && !visible) {
                return null;
            }
            _this.destroyClose = false;
            var containerStyle = {};
            var isDestroyOnClose = _this.getDestroyOnClose();
            if (isDestroyOnClose) {
                // Increase the opacity transition, delete children after closing.
                containerStyle.opacity = 0;
                containerStyle.transition = 'opacity .3s';
            }
            return (React.createElement("div", { className: "".concat(prefixCls, "-wrapper-body"), style: tslib_1.__assign(tslib_1.__assign({}, containerStyle), drawerStyle), onTransitionEnd: _this.onDestroyTransitionEnd },
                _this.renderHeader(),
                React.createElement("div", { className: "".concat(prefixCls, "-body"), style: bodyStyle }, _this.props.children),
                _this.renderFooter()));
        };
        // render Provider for Multi-level drawer
        _this.renderProvider = function (value) {
            var _a;
            _this.parentDrawer = value;
            var _b = _this.props, prefixCls = _b.prefixCls, placement = _b.placement, className = _b.className, mask = _b.mask, direction = _b.direction, visible = _b.visible, rest = tslib_1.__rest(_b, ["prefixCls", "placement", "className", "mask", "direction", "visible"]);
            var drawerClassName = (0, classnames_1.default)((_a = {
                    'no-mask': !mask
                },
                _a["".concat(prefixCls, "-rtl")] = direction === 'rtl',
                _a), className);
            var offsetStyle = mask ? _this.getOffsetStyle() : {};
            return (React.createElement(DrawerContext.Provider, { value: _this },
                React.createElement(rc_drawer_1.default, tslib_1.__assign({ handler: false }, (0, omit_1.default)(rest, [
                    'zIndex',
                    'closable',
                    'closeIcon',
                    'destroyOnClose',
                    'drawerStyle',
                    'headerStyle',
                    'bodyStyle',
                    'footerStyle',
                    'footer',
                    'title',
                    'push',
                    'width',
                    'height',
                ]), offsetStyle, { prefixCls: prefixCls, open: visible, showMask: mask, placement: placement, style: _this.getRcDrawerStyle(), className: drawerClassName }), _this.renderBody())));
        };
        return _this;
    }
    Drawer.prototype.componentDidMount = function () {
        // fix: delete drawer in child and re-render, no push started.
        // <Drawer>{show && <Drawer />}</Drawer>
        var visible = this.props.visible;
        if (visible && this.parentDrawer) {
            this.parentDrawer.push();
        }
    };
    Drawer.prototype.componentDidUpdate = function (preProps) {
        var visible = this.props.visible;
        if (preProps.visible !== visible && this.parentDrawer) {
            if (visible) {
                this.parentDrawer.push();
            }
            else {
                this.parentDrawer.pull();
            }
        }
    };
    Drawer.prototype.componentWillUnmount = function () {
        // unmount drawer in child, clear push.
        if (this.parentDrawer) {
            this.parentDrawer.pull();
            this.parentDrawer = null;
        }
    };
    Drawer.prototype.getOffsetStyle = function () {
        var _a = this.props, placement = _a.placement, width = _a.width, height = _a.height, visible = _a.visible, mask = _a.mask;
        // https://github.com/ant-design/ant-design/issues/24287
        if (!visible && !mask) {
            return {};
        }
        var offsetStyle = {};
        if (placement === 'left' || placement === 'right') {
            offsetStyle.width = width;
        }
        else {
            offsetStyle.height = height;
        }
        return offsetStyle;
    };
    Drawer.prototype.renderHeader = function () {
        var _a = this.props, title = _a.title, prefixCls = _a.prefixCls, closable = _a.closable, headerStyle = _a.headerStyle;
        if (!title && !closable) {
            return null;
        }
        var headerClassName = title ? "".concat(prefixCls, "-header") : "".concat(prefixCls, "-header-no-title");
        return (React.createElement("div", { className: headerClassName, style: headerStyle },
            title && React.createElement("div", { className: "".concat(prefixCls, "-title") }, title),
            closable && this.renderCloseIcon()));
    };
    Drawer.prototype.renderFooter = function () {
        var _a = this.props, footer = _a.footer, footerStyle = _a.footerStyle, prefixCls = _a.prefixCls;
        if (!footer) {
            return null;
        }
        var footerClassName = "".concat(prefixCls, "-footer");
        return (React.createElement("div", { className: footerClassName, style: footerStyle }, footer));
    };
    Drawer.prototype.renderCloseIcon = function () {
        var _a = this.props, closable = _a.closable, _b = _a.closeIcon, closeIcon = _b === void 0 ? React.createElement(NormalClose_1.NormalClose, { className: "drawer-close-icon" }) : _b, prefixCls = _a.prefixCls, onClose = _a.onClose;
        return (closable && (React.createElement("button", { type: "button", onClick: onClose, "aria-label": "Close", className: "".concat(prefixCls, "-close"), style: {
                '--scroll-bar': "".concat((0, getScrollBarSize_1.default)(), "px"),
            } },
            React.createElement("span", { role: "img", "aria-label": "close", className: "anticon anticon-close" }, closeIcon))));
    };
    Drawer.prototype.render = function () {
        return (
        // @ts-ignore
        React.createElement(DrawerContext.Consumer, null, this.renderProvider));
    };
    Drawer.defaultProps = {
        width: 256,
        height: 256,
        closable: true,
        placement: 'right',
        maskClosable: true,
        mask: true,
        level: null,
        keyboard: true,
        push: defaultPushState,
    };
    return Drawer;
}(React.Component));
var DrawerWrapper = function (props) {
    var customizePrefixCls = props.prefixCls, customizeGetContainer = props.getContainer;
    var _a = React.useContext(config_provider_1.ConfigContext), getPopupContainer = _a.getPopupContainer, getPrefixCls = _a.getPrefixCls, direction = _a.direction;
    var prefixCls = getPrefixCls('drawer', customizePrefixCls);
    var getContainer = 
    // 有可能为 false，所以不能直接判断
    customizeGetContainer === undefined && getPopupContainer
        ? function () { return getPopupContainer(document.body); }
        : customizeGetContainer;
    return (React.createElement(Drawer, tslib_1.__assign({}, props, { prefixCls: prefixCls, getContainer: getContainer, direction: direction })));
};
DrawerWrapper.displayName = 'DrawerWrapper';
exports.default = DrawerWrapper;
//# sourceMappingURL=index.js.map